import PaymentGateway from './PaymentGateway.js';

const PaymentForm = (user, catchResponse) => {
  const environment = 'stg';
  const application_code = 'WELLEZYSAS-STG-CO-CLIENT';
  const application_key = 'r1RqEYbG1gUaAJi5skzIPR9Lts59TN';
  const submitButton = document.querySelector('#tokenize_btn');
  const retryButton = document.querySelector('#retry_btn');
  const submitInitialText = submitButton.textContent;

  const get_tokenize_data = () => {
    const data = {
      locale: 'en',
      user: {
        id: user?.id,
        email: user?.email,
      },
      configuration: {
        default_country: 'COL',
      },
    };
    return data;
  };

  const notCompletedFormCallback = (message) => {
    console.log("notCompletedFormCallback: ---> ", message)
    document.getElementById('response').innerHTML = `Not completed form: ${message}, Please fill required data`;
    submitButton.innerText = submitInitialText;
    submitButton.removeAttribute('disabled');
  };

  const responseCallback = (response) => {
    console.log("responseCallback: ---> ", response)
    catchResponse(response)
    document.getElementById('response').innerHTML = JSON.stringify(response);
    retryButton.style.display = 'block';
    submitButton.style.display = 'none';
  };

  const pg_sdk = new PaymentGateway(environment, application_code, application_key);

  pg_sdk.generate_tokenize(get_tokenize_data(), '#tokenize_example', responseCallback, notCompletedFormCallback);

  submitButton.addEventListener('click', (event) => {
    document.getElementById('response').innerHTML = '';
    submitButton.innerText = 'Card Processing...';
    submitButton.setAttribute('disabled', 'disabled');
    pg_sdk.tokenize();
    event.preventDefault();
  });

  retryButton.addEventListener('click', (event) => {
    submitButton.innerText = submitInitialText;
    submitButton.removeAttribute('disabled');
    retryButton.style.display = 'none';
    submitButton.style.display = 'block';
    pg_sdk.generate_tokenize(get_tokenize_data(), '#tokenize_example', responseCallback, notCompletedFormCallback);
  });

};

export default PaymentForm;
